<template>
    <div class="page page-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="content">
            <div class="card">
                <div class="card-title">商品信息</div>
                <div class="pd-020">
                    <div class="input-field bd-bot click" @click="showCategoryPop = true;">
                        <div class="fs-32 color-333 left required">商品类目 </div>
                        <div class="field-content" :class="formItem.categoryName ? 'color-333':'color-999'">{{formItem.categoryName || '请选择商品类目'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>

                    <div class="filed-input-box bd-bot">
                        <div class="required fs-32 color-333">商品轮播图（800*800）</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-for="(item,$index) in formItem.imgList" :key="item.fileId">
                                <img :src="item.fileUrlView" alt="" >
                                <div class="clean" @click="delImg($index,'imgList')"></div>
                            </div>
                            <van-uploader v-model="imgList" :multiple="true" preview-size="1.45rem" :preview-image="false" :after-read="afterRead" v-show="formItem.imgList.length < 5"/>
                        </div>
                    </div>

                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">商品名称</div>
                        <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.productName" placeholder="请输入商品名称" />
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left">副标题</div>
                        <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.subTitle" placeholder="请输入副标题" />
                    </div>

                </div>
            </div>

            <div class="flex-center fs-32 color-333">
                <div class="selection flex-center click" @click="isSkuMul = false">
                    <div>单规格</div>
                    <div class="alifont" :class="[!isSkuMul?'icon-xuanzhong color-main':'icon-weixuanzhong color-666']"></div>
                </div>
                <div class="selection flex-center" style="margin-left: .8rem" @click="isSkuMul = true">
                    <div>多规格</div>
                    <div class="alifont" :class="[isSkuMul?'icon-xuanzhong color-main':'icon-weixuanzhong color-666']"></div>
                </div>
            </div>

            <div class="card pd-020" v-show="!isSkuMul">
                <div class="input-field bd-bot">
                    <div class="fs-32 color-333 left required">销售价</div>
                    <div class="fs-32 color-red">￥</div>
                    <van-field class="input" @click="inputClick" type="number" :clearable="true" v-model="formItem.specialPrice" placeholder="请输入销售价" />
                </div>
                <div class="input-field bd-bot">
                    <div class="fs-32 color-333 left">原价</div>
                    <div class="fs-32 color-red">￥</div>
                    <van-field class="input" @click="inputClick" type="number" :clearable="true" v-model="formItem.price" placeholder="请输入原价" />
                </div>
                <div class="input-field">
                    <div class="fs-32 color-333 left required">库存</div>
                    <van-field class="input" @click="inputClick" type="digit" :clearable="true" v-model="formItem.stockNum" placeholder="请输入商品库存" />
                </div>
            </div>

            <div v-show="isSkuMul">
                <div class="spec-list">
                    <div class="spec-item flex" v-for="(spec,$index) in specList" :key="$index">
                        <div class="left">{{spec.specName}}</div>
                        <div class="flex1 flex" style="flex-wrap: wrap">
                            <div class="spec-value-item" v-for="(value,$valueIndex) in spec.specValueList" :key="$valueIndex" >
                                {{value.specValueName}}
                                <img :src="closeImgUrl" alt="" class="clean-img click" @click="delSpecValue(value.specValueName,$index,$valueIndex)">
                            </div>
                            <div class="spec-value-add click" @click="addSpecValue($index)">
                                添加
                            </div>
                        </div>
                        <div class="right alifont icon-shanchu color-red click" @click="delSpec(spec.specName,$index)"></div>
                    </div>
                </div>
                <div class="pd-250 text-center fs-32 color-main click" @click="addSpec">
                    添加自定义规格
                </div>

                <div class="sku-list">
                    <div class="card" v-for="(item,$index) in specGridCell" :key="$index">
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="sku-spec-item" v-for="(skuName,$skuNameIndex) in item.specName" :key="$skuNameIndex"> {{skuName.value}}</div>
                        </div>
                        <div class="pd-020">
                            <div class="input-field bd-bot">
                                <div class="fs-32 color-333 left required">销售价</div>
                                <div class="fs-32 color-red">￥</div>
                                <van-field class="input" @click="inputClick" type="number" :clearable="true" v-model="item.specialPrice" placeholder="请输入销售价" />
                            </div>
                            <div class="input-field bd-bot">
                                <div class="fs-32 color-333 left">原价</div>
                                <div class="fs-32 color-red">￥</div>
                                <van-field class="input" @click="inputClick" type="number" :clearable="true" v-model="item.price" placeholder="请输入原价" />
                            </div>
                            <div class="input-field">
                                <div class="fs-32 color-333 left required">库存</div>
                                <van-field class="input" @click="inputClick" type="digit" :clearable="true" v-model="item.stockNum" placeholder="请输入商品库存" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-20">
                <div class="card-title">商品介绍</div>
                <div class="content-input">
                    <textarea @click="inputClick()" placeholder="输入商品介绍信息，如：购买需知，商品/套餐情况内容等（非必填）" v-model="formItem.intro"></textarea>
                </div>

                <div class="pd-020">
                    <div class="filed-input-box bd-bot">
                        <div class="required fs-32 color-333">详情页</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式照片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-for="(item,$index) in formItem.descpPicList" :key="item.fileId">
                                <img :src="item.descpPicView" alt="" >
                                <div class="clean" @click="delImg($index,'descpPicList')"></div>
                            </div>
                            <van-uploader v-model="imgList" :multiple="true" preview-size="1.45rem" :preview-image="false" :after-read="afterDescpPicRead" v-show="formItem.descpPicList.length < 10"/>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">确定</div>
        </div>
        <van-popup v-model="showCategoryPop" position="bottom">
            <van-picker show-toolbar :columns="columns" value-key="categoryName"  @cancel="showCategoryPop = false" @change="onChange" @confirm="onConfirm"  />
        </van-popup>

        <van-dialog v-model="addSpecShow" title="添加自定义规格" show-cancel-button  :before-close="sureAddSpec">
            <van-field class="dialog-input bd-bot" type="text" :clearable="true" v-model="newSpecName" :maxlength="4" placeholder="输入自定义规格，最多4个字"/>
        </van-dialog>

        <van-dialog v-model="addSpecValueShow" title="添加规格值" show-cancel-button :before-close="sureAddSpecValue">
            <van-field class="dialog-input bd-bot" type="text" :clearable="true" v-model="newSpecValueName" :maxlength="10" placeholder="输入规格值，最多10个字" />
        </van-dialog>

    </div>
</template>

<script>
    import uploadImg from "@/api/uploadImg"
    import {saveProduct,getProductDetail} from "@/api/product"
    import {getCategory} from "@/api/base"
    import {listConvertTree} from "@/utils/util"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "saveProduct",
        components: {backTitleBar},
        mixins:[inputFix],
        data() {
            return {
                formItem: {
                    goodsType: 'orderProductType',
                    imgList: [],
                    descpPicList:[],
                    freight: '0',
                },
                imgList: [],
                specList:[],
                specGridCell: [],
                showCategoryPop: false,
                columns: [],
                categoryList: [],
                itemId: '',
                isSkuMul:false,
                closeImgUrl: require("../../assets/images/clean_black.png"),
                addSpecShow:false,
                addSpecValueShow:false,
                newSpecName:'',
                newSpecValueName:'',
                shopId: this.$store.state.user.shopId
            }
        },
        created() {
            this.itemId = this.$route.query.itemId;
            if (this.itemId) {
                this.getDetail();
            }
            this.getCategory();

        },
        methods: {
            inputClick(){
                window.setTimeout(function() {
                  document.activeElement.scrollIntoView({block:"center"})
                }, 200);
            },
            //获取分类
            getCategory() {
                getCategory({businessType: 'orderProductType'}).then(res => {
                    let opt = {
                        primaryKey: 'categoryId',
                        parentKey: 'parentId',
                        startPid: '-1'
                    }
                    let data = listConvertTree(res.data, opt)
                    this.setSelectTree(data)
                })
            },
            setSelectTree(data) {
                let categoryList = data;
                this.columns = [
                    {
                        values: categoryList,  // 设置的页面初始值
                        className: "column1"
                    },
                    {
                        values: categoryList[0].children,
                        className: "column2"
                    },
                    {
                        values: categoryList[0].children[0].children,
                        className: "column3"
                    }
                ]
            },

            //选中分类
            onConfirm(value) {
                if (value[2]) {
                    this.$set(this.formItem, 'categoryId', value[2].categoryId);
                    this.$set(this.formItem, 'categoryName', value[2].categoryName);
                } else {
                    this.$set(this.formItem, 'categoryId', value[1].categoryId);
                    this.$set(this.formItem, 'categoryName', value[1].categoryName);
                }

                this.showCategoryPop = false;
            },
            onChange(picker, values, index) {
                picker.setColumnValues(index + 1, values[index].children || []); //点当前列更新下一列数据，防止undefined
                if (index == 0) {
                    picker.setColumnValues(2, values[index].children[0].children || []); // 防止突然选中第一个，第二个是更新的，但第三个联级不更新，我暂时强制清空
                }
            },

            //获取商品详情
            getDetail() {
                getProductDetail(this.itemId).then(res => {
                    let obj = res.data;
                    if(res.data.specList.length == 0 ){
                        this.isSkuMul = false;
                        let spec = res.data.skuList[0];
                        obj.specName = spec.specName;
                        obj.warnNum = spec.warnNum;
                        obj.stockNum = spec.stockNum;
                        obj.itemSkuId = spec.itemSkuId;
                        obj.skuId = spec.skuId;
                    }else{
                        this.isSkuMul = true;
                        this.specList = res.data.specList;
                        res.data.skuList.forEach(item=>{
                            item.specName = item.specName.split(";");
                            let specNameArr = [];
                            item.specName.forEach(spec=>{
                                let specItem = {
                                    name:spec.split(":")[0],
                                    value:spec.split(":")[1]
                                }
                                specNameArr.push(specItem)
                            })
                            item.specName = specNameArr
                        })
                        this.specGridCell = res.data.skuList;
                    }

                    this.formItem = Object.assign({}, this.formItem, obj);
                })
            },
            //删除图片
            delImg($index,type) {
                this.formItem[type].splice($index, 1)
            },

            //选中图片后上传服务器
            async uploadImgFun(file) {
                let result = await uploadImg(file.file, 'product')
                this.formItem.imgList.push(result)
            },
            //选中图片后上传服务器
            async uploadDescpImgFun(file) {
                let result = await uploadImg(file.file, 'product')
                result.descpPicView = result.fileUrlView;
                result.descpPic = result.fileUrl;
                this.formItem.descpPicList.push(result)
            },
            afterRead(file){
                //图片上传组件多选 安卓回调一张返回object 多张返回array
                if(Array.isArray(file)){
                    if(file.length > 0){
                        file.forEach(item=>{
                            this.uploadImgFun(item)
                        })
                    }
                }else{
                    this.uploadImgFun(file)
                }

            },
            afterDescpPicRead(file){
                //图片上传组件多选 安卓回调一张返回object 多张返回array
                if(Array.isArray(file)){
                    if(file.length > 0){
                        file.forEach(item=>{
                            this.uploadDescpImgFun(item)
                        })
                    }
                }else{
                    this.uploadDescpImgFun(file)
                }
            },


            submitForm() {
                let form = this.formItem;
                form.stockNum = String(form.stockNum);
                form.freight = String(form.freight);
                form.specialPrice = String(form.specialPrice);
                if (!form.productName || !form.categoryId || !(form.freight)) {
                    this.$toast("请填写必填项目");
                    return
                }
                let skuList = [];
                let specList = [];
                if(this.isSkuMul){
                    let returnBol = false;
                    this.specList.forEach(item=>{
                        if(item.specValueList.length < 1){
                            returnBol = true;
                            return
                        }
                        let specItem = {
                            specId: item.specId || '',
                            specName : item.specName,
                            isAddImg: item.isAddImg,
                            specValueList: item.specValueList
                        }
                        specList.push(specItem);
                    })
                    if(returnBol){
                        this.$toast("规格值选项不能为空");
                        return false
                    }
                    this.specGridCell.forEach(item=>{
                        if(!item.specialPrice || !String(item.stockNum)){
                            returnBol = true;
                            return
                        }
                        let skuItem = {
                            itemSkuId: item.itemSkuId || '',
                            skuId: item.skuId || '',
                            specName: item.specName.map(function(specNameItem){
                                return specNameItem.name + ":" + specNameItem.value
                            }).join(";"),
                            price: item.price || item.specialPrice,
                            specialPrice: item.specialPrice,
                            stockNum: item.stockNum || 0
                        }
                        skuList.push(skuItem)
                    })
                    if(returnBol){
                        this.$toast("请填写sku销售价和库存");
                        return false
                    }
                }else{
                    if (!form.specialPrice || !form.stockNum ) {
                        this.$toast("请填写必填项目");
                        return
                    }
                    let sku = {
                        price: form.price || form.specialPrice,
                        specialPrice: form.specialPrice,
                        stockNum: form.stockNum
                    }
                    if (form.skuId && form.itemSkuId) {
                        sku.skuId = form.skuId;
                        sku.itemSkuId = form.itemSkuId;
                    }
                    skuList = [sku]
                }
                let params = {
                    categoryId: form.categoryId,
                    categoryName: form.categoryName,
                    productName: form.productName,
                    intro: form.intro,
                    goodsType: form.goodsType,
                    // descp:form.descp,
                    subTitle: form.subTitle,
                    freight: form.freight,
                    skuList: JSON.stringify(skuList),
                    specList: JSON.stringify(specList),
                    unitName: form.unitName || '',
                    shopIds: this.shopId,
                    itemId: form.itemId || ''
                }
                if (this.formItem.imgList.length != 0) {
                    params.addImgIds = form.imgList.map(function (file) {
                        return file.fileId
                    }).join(",")
                    params.addImgSeq = form.imgList.map(function (file, $index) {
                        return $index
                    }).join(",")
                }
                if(form.descpPicList.length != 0){
                    let descpArr = [];
                    form.descpPicList.forEach(pic=>{
                        let obj = {
                            picId: pic.picId || null,
                            productId: form.productId || null,
                            descpPic: pic.descpPic,
                        }
                        descpArr.push(obj);
                    })
                    params.descpPicList = JSON.stringify(descpArr)
                };
                //状态为审核失败 修改需要把状态改成待审核
                if(form.state == 3){
                    params.state = 0;
                }
                saveProduct(params).then(res => {
                    if (res.code === 0) {
                        this.$toast('保存成功');
                        this.$store.state.updateProductList = true;
                        this.$router.back();

                    }
                }).finally(() => {

                })
            },

            //添加自定义规格 ---弹窗
            addSpec(){
                this.addSpecShow = true;
            },
            //确定添加自定义规格
            sureAddSpec(action,done){
                if(this.newSpecName){
                    let obj = this.searchObjectByKey(this.specList,'specName',this.newSpecName);
                    if(obj){
                        this.$toast('该规格名已存在，请重新设置');
                        done(false);
                    }else{
                        this.specList.push({
                            specName: this.newSpecName,
                            isAddImg:0,
                            specValueList: []
                        });
                        this.newSpecName = '';
                        this.addSpecShow = false;
                        done();
                    }
                }else{
                    this.addSpecShow = false;
                    done();
                }
            },
            //删除规格项
            delSpec(specName,$specIndex){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: `确定要删除 '${specName}' 规格项？`,
                    showCancelButton: true
                }) .then(() => {     //点击确认按钮后的调用
                        _this.specList.splice($specIndex,1)
                        _this.generateSpec();
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },

            //添加规格属性值 ---弹窗
            addSpecValue($specIndex){
                this.editSpecIndex = $specIndex;
                this.addSpecValueShow = true;
            },
            //确定添加规格属性值
            sureAddSpecValue(action,done){
                if(this.newSpecValueName){
                    let obj = this.searchObjectByKey(this.specList[this.editSpecIndex].specValueList,'specValueName',this.newSpecValueName);
                    if(obj){
                        this.$toast('该规格值已存在，请重新设置');
                        done(false);
                    }else{
                        this.specList[this.editSpecIndex].specValueList.push({
                            specValueName: this.newSpecValueName,
                            specValueId:'',
                            specValuePic:''
                        })
                        this.newSpecValueName = '';
                        this.addSpecValueShow = false;
                        this.generateSpec();
                        done();
                    }
                }else{
                    this.addSpecValueShow = false;
                    done();
                }
            },
            //删除规格属性值
            delSpecValue(valueName,$specIndex,$valueIndex){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: `确定要删除 '${valueName}' 规格值？`,
                    showCancelButton: true
                }) .then(() => {     //点击确认按钮后的调用
                    _this.specList[$specIndex].specValueList.splice($valueIndex,1)
                    _this.generateSpec();
                })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },

            // 生成规格的全排列函数
            generate(arr) {
                function mix(item1, item2) {
                    var arr1 = Array.isArray(item1.specValueList) ? item1.specValueList : item1;
                    var arr2 = item2.specValueList;
                    var result = [];
                    for (let i = 0; i < arr1.length; i++) {
                        for (let j = 0; j < arr2.length; j++) {
                            let item = [];
                            if (Array.isArray(arr1[i])) {
                                item = item.concat(arr1[i]);
                                item.push({
                                    name: item2.specName,
                                    value: arr2[j].specValueName
                                });
                            } else {
                                item.push({
                                    name: item1.specName,
                                    value: arr1[i].specValueName
                                });
                                item.push({
                                    name: item2.specName,
                                    value: arr2[j].specValueName
                                });
                            }
                            result.push(item);
                        }
                    }
                    return result;
                }
                if (arr.length < 1) {
                    return [];
                } else if (arr.length < 2) {
                    let result = [];
                    let item = arr[0];
                    item.specValueList.map(value => {
                        result.push([{
                            name: item.specName,
                            value: value.specValueName
                        }]);
                    });
                    return result;
                } else {

                    return arr.reduce((acc, item) => {
                        return mix(acc, item);
                    });
                }

            },
            // 生成规格
            generateSpec() {

                // 过滤空白的规格
                let normlizeList = this.specList.map(item => {
                    return {
                        specName: item.specName,
                        specValueList: item.specValueList.filter(value => value.specValueName)
                    }
                });
                // 获取规格数据
                this.specGridCell = this.generate(normlizeList).map(item => {
                    return {
                        specName: item,
                        specialPrice: "",
                        price: "",
                        stockNum: "",
                    };
                });
                console.log(this.specGridCell)
            },

            // 从集合中查询某个名称的值是否存在
            searchObjectByKey(list, keyName, keyValue,index) {
                if(!isNaN(index)){
                    for (var i = 0; i < list.length; i++) {
                        if (list[i][keyName] == keyValue && i != index) {
                            return list[i];
                        }
                    }
                }else{
                    for (var i = 0; i < list.length; i++) {
                        if (list[i][keyName] == keyValue) {
                            return list[i];
                        }
                    }
                }
                return null;
            },

        },
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }

    .content-input textarea{
        width: 100%;
        height: 2.5rem;
        border: none;
        outline: none;
        background: none;
        font-size: .32rem;
        line-height: .45rem;
        color: #333;
        padding: .2rem .35rem;
    }
    .selection{
        padding: .4rem 0;
        .alifont{
            margin-left: .1rem;
            font-size: .48rem;
        }
    }

    .spec-item{
        background: #fff;
        border-radius: .12rem;
        padding: .22rem .25rem 0 .35rem;
        margin-bottom: .08rem;
        &:last-child{
            margin-bottom: 0;
        }
        .left{
            width: 1.2rem;
            margin-right: .2rem;
            font-size: .32rem;
            line-height: .4rem;
            color: #333;
            font-weight: bold;
            padding-top: .12rem;
        }
        .right{
            font-size: .44rem;
        }
    }
    .spec-value-item{
        height: .64rem;
        line-height: .64rem;
        padding: 0 .25rem;
        background: $main-color;
        border-radius: .06rem;
        margin-right: .45rem;
        position: relative;
        font-size: .32rem;
        color: #fff;
        margin-bottom: .24rem;
        .clean-img{
            position: absolute;
            width: .36rem;
            height: .36rem;
            top: -.1rem;
            right: -.1rem;
            z-index: 10;
        }
    }
    .spec-value-add{
        height: .64rem;
        line-height: .64rem;
        padding: 0 .25rem;
        background:#fff;
        border-radius: .06rem;
        font-size: .32rem;
        color: $main-color;
        margin-bottom: .24rem;
        border: .01rem solid $main-color;
    }
    .sku-spec-item{
        line-height: .64rem;
        height: .64rem;
        padding: 0 .25rem;
        margin-right: .16rem;
        margin-bottom: .2rem;
        background: $main-color;
        color: #fff;
        font-size: .32rem;
    }
    .sku-list .card{
        margin-bottom: .08rem;
        &:last-child{
            margin-bottom: 0;
        }
    }

    .dialog-input{
        margin: .65rem .48rem;
        font-size: .34rem;
        color: #000;
        line-height: .48rem;
    }
</style>



// WEBPACK FOOTER //
// saveProduct.vue?7aa67262